import { Config } from "../../../../api/config";
export var EditCustomerInfoKeys = {
    SendMobileOtp: 'SendMobileOtp',
    VerifyMobileOtp: 'VerifyMobileOtp'
};
export var LanguageListAPI = "".concat(Config.baseURL, "Language/ChannelList");
export var VIContactPreferencePickListAPI = "".concat(Config.baseURL, "CommunicationType/List");
export var getCustomerByIdAPI = function (id) {
    return "".concat(Config.baseURL, "Customer/").concat(id, "/Get");
};
export var updateCustomerInfoURL = function (id) {
    return "".concat(Config.baseURL, "Customer/").concat(id, "/UpdateCustomerPreference");
};
export var SendMobileOtp = "".concat(Config.baseURL, "Verification/ProxySendMobileOTP");
export var VerifyMobileOtp = "".concat(Config.baseURL, "Verification/ProxyVerifyMobileOTP");
export var UpdateCustomerInfo = function (id) { return "".concat(Config.baseURL, "Customer/").concat(id, "/UpdateCustomerPreference"); }; //30da31c1-87dd-4db2-88e8-471aa392cb3d
